module.exports = __webpack_public_path__ + "static/media/spinach-mozzarella-ricotta-dumpling.49696311.png";